import {gsap} from "gsap";

class Intromovie {
    constructor(){
        this.context = $(".intro-movie");
        this.movie = promokit.video({
            el: `[data-movie="intro"]`,
            url: `https://vod.plaync.com/Aion/update/201015/Classic_Intro_low.mp4`,
            controls: false,
            autoplay: false,
            loop: false,
            preload: true
        });
        this.setEvent();
    }

    start() {
        $('.intro-movie').show();
        gsap.from($('.intro-movie'), 0.8, {autoAlpha:1});
        this.movie.play();
        this.isPlayed = true;
    }

    end() {
        gsap.to($(".intro-movie"), 0.8, {autoAlpha:0, onComplete:() => {
                $(".intro-movie").hide();
            }});

        this.context.trigger('done');
        this.movie.pause();
    }

    setEvent() {
        this.movie.on("ended", ()=>{
            this.end();
        });

        $(".intro-movie__btn").on("click", () => {
            this.end();
        });
    }

    on(event, fn) {
        this.context.on(event, fn);
    }
}

export default Intromovie;


// WEBPACK FOOTER //
// ./src/js/intromovie.js